import React from "react";
import "./NetworkStatusIndicator.scss";

interface NetworkStatusIndicatorProps {
    isReconnecting: boolean;
    isRefetching?: boolean;
    onRetry?: () => void;
}

const NetworkStatusIndicator: React.FC<NetworkStatusIndicatorProps> = ({
    isReconnecting,
    isRefetching = false,
    onRetry,
}) => {
    // Show indicator if either network is reconnecting OR data is actively refetching
    const shouldShow = isReconnecting || isRefetching;

    if (!shouldShow) {
        return null;
    }

    return (
        <div className="network-status-indicator">
            <div className="network-status-content">
                <div className="network-status-icon">
                    <div className="network-spinner"></div>
                </div>
                <span className="network-status-text">
                    {isRefetching ? "Loading fresh data..." : "Reconnecting..."}
                </span>
            </div>
        </div>
    );
};

export default NetworkStatusIndicator;